import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LangSelector, AlertButton } from 'libs/ui';
import { openWindow } from 'store/actions/windows';
import { UserBlock } from './user-block';
import { DesignSwitch } from './design-switch';
import { InfoBlock } from './info-block';
import { Content, Bar } from './header.styled';

export const Header = () => {
  const dispatch = useDispatch();
  const doOpenWindow = useCallback((data) => dispatch(openWindow(data)), [dispatch]);

  return (
    <Content>
      <Bar>
        <AlertButton openWindow={doOpenWindow} />
        <LangSelector flags abs={false} />
        <InfoBlock openWindow={doOpenWindow} />
        <DesignSwitch />
        <UserBlock openWindow={doOpenWindow} />
      </Bar>
    </Content>
  );
};
